import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { App } from './App.tsx'
import './i18n' // Load translation system

import * as ReactRedux from 'react-redux';
import * as ReduxToolkit from '@reduxjs/toolkit';
import * as ReactI18next from 'react-i18next';

import i18next from 'i18next';
import { registerShare } from '@bfme-technology/spa';

// Register core dependencies for MFEs using our SPA package
registerShare('react-redux', '9.3.0', ReactRedux, 'bfme-wealthiq-core');
registerShare('@reduxjs/toolkit', '2.12.0', ReduxToolkit, 'bfme-wealthiq-core');
registerShare('react-i18next', '17.0.8', ReactI18next, 'bfme-wealthiq-core');

registerShare('i18next', '26.3.1', i18next, 'bfme-wealthiq-core');

// Global fetch interceptor to catch 401s and GraphQL unauthenticated errors across core app and MFEs
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const response = await originalFetch(...args);
  if (response.status === 401) {
    window.dispatchEvent(new CustomEvent('app-unauthorized'));
  } else if (response.ok) {
    try {
      const clone = response.clone();
      const contentType = response.headers.get('content-type') || '';
      if (contentType.includes('application/json')) {
        const json = await clone.json();
        if (json && Array.isArray(json.errors)) {
          const isUnauth = json.errors.some((err: any) => {
            const msg = (err?.message || '').toLowerCase();
            const code = (err?.extensions?.code || '').toUpperCase();
            const category = (err?.extensions?.category || '').toLowerCase();
            return (
              msg.includes('unauthenticated') ||
              code === 'UNAUTHENTICATED' ||
              category === 'authentication' ||
              category === 'unauthenticated'
            );
          });
          if (isUnauth) {
            window.dispatchEvent(new CustomEvent('app-unauthorized'));
          }
        }
      }
    } catch (e) {
      // ignore json clone read failure
    }
  }
  return response;
};
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
